import { AddressableViewLayout } from 'framework/ViewTypes';
import { FormBuilder, type FormDefinition, type SubmissionValues } from '../form-engine';

const saveForm = async (definition: FormDefinition, previewValues?: SubmissionValues) => {
  throw new Error('Not implemented yet');
};

const CreateTaskConstructorLayout = () => {
  return <AddressableViewLayout contentLayout={<FormBuilder onSave={saveForm} />} />;
};

export default CreateTaskConstructorLayout;
